<template>
    <az-container>
        <v-form
            ref="form"
            lazy-validation
            class="az-form-content px-0 d-flex flex-column pb-0"
        >
            <v-select
                v-model="certificado"
                :items="certificados"
                v-validate="'required'"
                item-text="prettyName"
                item-value="thumbprint"
                class="mb-2"
                name="certificado"
                placeholder="Selecione um certificado digital"
                :error-messages="errors.collect('certificado')"
            >
                <template v-slot:label>
                    Certificado
                    <span class="ml-1 red--text">*</span>
                </template>
            </v-select>

            <div>
                <campo-apresentacao label-padrao="Anexo" :text="nomeAnexo | textoSemValorSimples" :maxTruncate="50"/>
            </div>
        </v-form>
    </az-container>
</template>

<script>
    import actionTypes from '@/core/constants/action-types'
    import { AzDigitalSignature, LoadingScreen } from '@/core/utils'
    import CampoApresentacao from '@/views/components/campos/CampoApresentacao.vue'

    export default {
        name: 'AssinaturaDigital',

        components: {
            CampoApresentacao,
        },

        data() {
            return {
                certificados: [],
                certificado: '',
                assinaturaDigital: null,
                loadingScreen: null,
            }
        },

        props: {
            nomeAnexo: {
                type: String,
                required: true,
            },
        },

        mounted() {
            this.instanciarAzDigitalSignature()
        },

        methods: {
            async instanciarAzDigitalSignature() {
                this.loadingScreen = new LoadingScreen(this.$store)
                const licencaLacuna = await this.buscarLicencaLacuna()

                this.assinaturaDigital = new AzDigitalSignature({
                    store: this.$store,
                    licencaLacuna
                })

                await this.iniciarAssinatura()
            },
            async buscarLicencaLacuna() {
                return await this.$store.dispatch((actionTypes.DOCUMENTO.BUSCAR_LICENCA_LACUNA_FLOWBEE))
            },
            fecharModalAssinatura() {
                this.loadingScreen.stop()
                this.$emit('cancelar')
            },
            async iniciarAssinatura() {
                this.setMensagemLoading('Iniciando serviço de assinatura...')

                this.loadingScreen.start()
                const webPkiInstalled = await this.assinaturaDigital.loadWebPki()
                this.loadingScreen.stop(true)

                if (!webPkiInstalled) {
                    this.exibirModalExtensaoNaoInstalada()
                    return
                }

                this.certificados = await this.assinaturaDigital.listCertificates()
            },
            exibirModalExtensaoNaoInstalada() {
                this.mostrarConfirmacao(
                    {
                        titulo: 'Extensão Lacuna WebPki',
                        subTitulo: 'A extensão WebPki é necessária para continuar o processo da assinatura digital.\nDeseja instalar agora?',
                        textoBotaoConfirm: 'SIM',
                        textoBotaoCancel: 'NÃO',
                        icon: 'warning'
                    },
                    ({ isConfirmed, isDismissed }) => {
                        if (isConfirmed) this.confirmarModalExtensaoNaoInstalada()
                        if (isDismissed) this.fecharModalAssinatura()
                    }
                )
            },
            confirmarModalExtensaoNaoInstalada() {
                this.assinaturaDigital.redirectToInstallWebPki()
            },
            assinar({ id }) {
                this.setMensagemLoading('Assinando documento...')
                this.loadingScreen.start()
                this.assinaturaDigital
                    .sign(this.certificado, id)
                    .then(async () => {
                        this.loadingScreen.stop(true)
                        this.mostrarNotificacaoSucesso('Documento assinado com sucesso!')
                        this.fecharModalAssinatura()
                        this.$emit('assinatura-realizada')
                    })
                    .catch((erro) => {
                        this.loadingScreen.stop(true)
                        this.tratarErroAssinatura(erro)
                    })
            },
            tratarErroAssinatura(erro) {
                const tipoErrosLacuna = {
                    licencaInvalidaNoDominio: 'The given license is not valid for use on the current domain:',
                }

                if (erro.response && erro.response.data) {
                    this.mostrarNotificacaoErro(erro.response.data.message)
                } else if (erro.match(tipoErrosLacuna.licencaInvalidaNoDominio)) {
                    const dominio = erro.replace(tipoErrosLacuna.licencaInvalidaNoDominio, '')
                    this.mostrarNotificacaoErro('A licença atual não é válida para o domínio:' + dominio)
                } else {
                    this.mostrarNotificacaoErro(erro)
                }
            },
        }
    }
</script>
